import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import React from "react"
import {FilterExpander} from "../common/FilterExpander";
import PickFilterView from './PickFilterView'
const PickFilterViewWrapper = () => {
    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <PickFilterView />
                </FilterExpander> :
                <PickFilterView />}
        </React.Fragment>
    )

}
export default PickFilterViewWrapper


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickFilterViewWrapper.js